import ChannelCurves from './ChannelCurves'
import ChannelCurvesChart from './ChannelCurvesChart'
import ChannelCurvesChartMulti from './ChannelCurvesChartMulti'
import ChannelCurvesChartMultiInstance from './ChannelCurvesChartMultiInstance'
import ChannelSaturation from './ChannelSaturation'
import ComparativeMixChart from './ComparativeMixChart'
import MarketingSales from './MarketingSales'
import MarketingSalesByMicroaudience from './MarketingSalesByMicroaudience'
import MarketingSalesDetail from './MarketingSalesDetail'
import MarketingSalesDetailChannel from './MarketingSalesDetailChannel'
import MarketingSalesDetailChannelSegment from './MarketingSalesDetailChannelSegment'
import MarketingSpend from './MarketingSpend'
import MarketingSpendDetail from './MarketingSpendDetail'
import MarketingSpendDetailChannel from './MarketingSpendDetailChannel'
import MarketingSpendDetailChannelTouchpoint from './MarketingSpendDetailChannelTouchpoint'
import MarketingSpendSegmentsDetail from './MarketingSpendSegmentsDetail'
import PieBullet from './PieBullet'
import PieMetric from './PieMetric'
import RoasByChannel from './RoasByChannel'
import SalesBySegment from './SalesBySegment'
import SalesBySegmentChart from './SalesBySegmentChart'
import SalesDecomposition from './SalesDecomposition'
import SegmentStackedBar from './SegmentStackedBar'

export default {
  ChannelCurves,
  ChannelCurvesChart,
  ChannelCurvesChartMulti,
  ChannelCurvesChartMultiInstance,
  ChannelSaturation,
  ComparativeMixChart,
  MarketingSales,
  MarketingSalesByMicroaudience,
  MarketingSalesDetail,
  MarketingSalesDetailChannel,
  MarketingSalesDetailChannelSegment,
  MarketingSpend,
  MarketingSpendDetail,
  MarketingSpendDetailChannel,
  MarketingSpendDetailChannelTouchpoint,
  MarketingSpendSegmentsDetail,
  PieBullet,
  PieMetric,
  RoasByChannel,
  SalesBySegment,
  SalesBySegmentChart,
  SalesDecomposition,
  SegmentStackedBar
}
